import React, { useContext } from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';

import { ReactComponent as HeatIcon } from '@hvcgroep/design-system/assets/illustrations/Warmte.svg';
import { ReactComponent as GasIcon } from '@hvcgroep/design-system/assets/illustrations/Gas.svg';
import { ReactComponent as CostsIcon } from '@hvcgroep/design-system/assets/illustrations/Termijnbedrag.svg';

import { COSTS_VERDICT_EXPENSIVE, DEFAULT_GAS_PRICE } from '../../config/constants';
import DataContext from '../../contexts/DataContext';
import { calculateTotalAnnualGasPrice } from '../../helpers/calculations';


import './style.scss';
import Button from '../../../../shared/components/Button';

type ResultsBlockType = 'cheap' | 'neutral' | 'expensive';

interface IconProps {
  type: ResultsBlockType;
}

const ResultsBlockIcon: React.FC<IconProps> = (props) => {
  const { type } = props;

  switch (type) {
    case 'cheap':
      return <HeatIcon />;
    case 'expensive':
      return <GasIcon />;
    default:
      return <CostsIcon />;
  }
};

interface Props {
  type: ResultsBlockType;
  className?: string;
  onReset: () => void;
}

const ResultsBlock: React.FC<Props> = ({
  type,
  className,
  onReset,
}) => {
  const { t } = useTranslation();

  const {
    gasConsumption,
    gasGridManagementCost,
    gasFixedCost,
    cvInstallationCost,
    cvMaintenanceCost,
  } = useContext(DataContext);

  const classNames = c(
    'ResultsBlock',
    `ResultsBlock--${type}`,
    className,
  );

  return (
    <article className={classNames}>
      <div className="ResultsBlock__icon">
        <ResultsBlockIcon type={type} />
      </div>

      <h3 className="h4">{t(`heat_calculator.results_block.titles.${type}`)}</h3>
      <p>
        {t(`heat_calculator.results_block.bodies.${type}`, {
          defaultGasPrice: Number(DEFAULT_GAS_PRICE).toFixed(2).replace('.', ','),
          totalGasPrice: calculateTotalAnnualGasPrice(
            gasConsumption,
            DEFAULT_GAS_PRICE,
            gasGridManagementCost,
            gasFixedCost,
            cvInstallationCost,
            cvMaintenanceCost,
          ).toFixed(2).replace('.', ','),
        })}
      </p>

      {type === COSTS_VERDICT_EXPENSIVE && (
        <Button icon="arrow_upward" onClick={onReset}>
          {t('heat_calculator.buttons.restart_calculation')}
        </Button>
      )}
    </article>
  );
};

export default ResultsBlock;
